import { CheckoutOrderQuery } from '@/__generated__/graphql';
import { useMutation } from '@apollo/client';
import { Alert, Button, Card, Group, Stack, Text, useMantineTheme } from '@mantine/core';
import { IconEdit, IconTruckDelivery } from '@tabler/icons-react';
import { setPaymentMethodOnCheckoutOrderDocument } from '../graphql/mutations';
import { checkoutOrderDocument } from '../graphql/queries';
import { useState } from 'react';

export const OrderCheckoutPaymentSelect = ({
  order,
}: {
  order: CheckoutOrderQuery['checkoutOrder'];
}) => {
  const theme = useMantineTheme();

  const [isEdit, setEdit] = useState(false);

  const [setPaymentMethod] = useMutation(setPaymentMethodOnCheckoutOrderDocument, {
    refetchQueries: [checkoutOrderDocument],
  });

  if (!order.paymentMethodId || isEdit) {
    return (
      <Card p="md" withBorder component={Stack}>
        <Text fw={500}>Vyberte spôsob platby</Text>
        {!order.shippingMethodId ? (
          <Alert color="red">Najprv zvoľte spôsob dopravy</Alert>
        ) : (
          order.availablePaymentMethods.length === 0 && (
            <Alert color="red">Nie sú dostupné žiadne možnosti platby</Alert>
          )
        )}
        <Stack>
          {order.availablePaymentMethods.map(({ id, name, description, fee }) => (
            <Card
              key={id}
              p="md"
              withBorder
              style={{
                cursor: 'pointer',
                borderColor:
                  order.paymentMethodId === id ? theme.colors.blue[6] : theme.colors.dark[4],
              }}
              onClick={async () => {
                await setPaymentMethod({ variables: { orderId: order.id, paymentMethodId: id } });
                setEdit(false);
              }}
            >
              <Group justify="space-between">
                <Group>
                  <IconTruckDelivery size={16} />
                  <Stack gap={0}>
                    <Text>{name}</Text>
                    <Text size="sm" c="dimmed">
                      {description}
                    </Text>
                  </Stack>
                </Group>
                {fee > 0 && <Text>{fee} €</Text>}
              </Group>
            </Card>
          ))}
        </Stack>
      </Card>
    );
  } else {
    const method = order.availablePaymentMethods.find(
      (method) => method.id === order.paymentMethodId
    );

    if (!method)
      return (
        <Card p="md" withBorder component={Stack}>
          <Text fw={500}>Zvolený spôsob platby</Text>
          <Alert color="red">Nepodarilo sa načítať zvolený spôsob platby! Kontaktujte nás.</Alert>
        </Card>
      );

    return (
      <Card p="md" withBorder component={Stack}>
        <Text fw={500}>Zvolený spôsob platby</Text>
        <Card
          p="md"
          withBorder
          style={{
            cursor: 'pointer',
            borderColor: theme.colors.blue[6],
          }}
        >
          <Group justify="space-between">
            <Group>
              <IconTruckDelivery size={16} />
              <Stack gap={0}>
                <Text>{method.name}</Text>
                <Text size="sm" c="dimmed">
                  {method.description}
                </Text>
              </Stack>
            </Group>
            {method.fee > 0 && <Text>{method.fee} €</Text>}
            {order.availablePaymentMethods.filter((m) => m.id !== order.paymentMethodId).length >
              0 && (
              <Button size="xs" leftSection={<IconEdit size={16} />} onClick={() => setEdit(true)}>
                Zmeniť
              </Button>
            )}
          </Group>
        </Card>
      </Card>
    );
  }
};
